import { enableBatching } from 'redux-batched-actions';

const initialState = {};

const reductions = {
    UPDATE_EVENT: (state, action) => {
        return Object.assign({}, state, action.payload);
    }
};

const eventReducer = (state = initialState, action) => {
    if(action && action.type && reductions[action.type]) {
        return reductions[action.type](state, action)
    }
    return state;
};

export default enableBatching(eventReducer);